
import { useState, FormEvent } from 'react';

export default function BlogEmailSignup() {
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);

      const response = await fetch('https://readdy.ai/api/form/d6jfdircs59vsrrrk1ig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString(),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-16 px-6 bg-gradient-to-br from-green-50 to-amber-50">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-gradient-to-br from-amber-600 to-green-700 flex items-center justify-center shadow-lg">
          <i className="ri-newspaper-line text-2xl text-white"></i>
        </div>
        <h2 className="font-playfair text-3xl font-bold text-gray-900 mb-3">
          Never Miss a Story
        </h2>
        <p className="text-gray-600 mb-8 leading-relaxed">
          Join our email list and get the latest birth stories, maternal wellness tips, and community updates delivered straight to your inbox.
        </p>

        {status === 'success' ? (
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-green-200">
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-checkbox-circle-fill text-3xl text-green-600"></i>
            </div>
            <h3 className="font-bold text-gray-800 text-xl mb-2">You're on the list! 🌸</h3>
            <p className="text-gray-500 text-sm">Thank you for joining. We'll be in touch with stories and updates soon.</p>
          </div>
        ) : (
          <form
            id="blog-email-signup-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="bg-white rounded-2xl shadow-xl p-8 border border-amber-100"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div className="text-left">
                <label htmlFor="blog-name" className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Your Name
                </label>
                <input
                  type="text"
                  id="blog-name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  placeholder="Your full name"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none text-sm transition-colors"
                />
              </div>
              <div className="text-left">
                <label htmlFor="blog-email" className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Email Address
                </label>
                <input
                  type="email"
                  id="blog-email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  placeholder="your@email.com"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none text-sm transition-colors"
                />
              </div>
            </div>

            {status === 'error' && (
              <p className="text-red-600 text-sm mb-4 flex items-center gap-2">
                <i className="ri-error-warning-line"></i>
                Something went wrong. Please try again.
              </p>
            )}

            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full py-3.5 bg-gradient-to-r from-amber-600 to-green-700 text-white font-bold rounded-xl hover:from-amber-700 hover:to-green-800 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {status === 'loading' ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i> Subscribing...
                </span>
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-send-plane-fill"></i> Join the Email List
                </span>
              )}
            </button>
            <p className="text-xs text-gray-400 mt-3">We respect your privacy. Unsubscribe anytime.</p>
          </form>
        )}
      </div>
    </section>
  );
}
